var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.appReady
    ? _c(
        "div",
        { staticClass: "root" },
        [
          _c("app-lock-screen"),
          _vm.isPlanExpired && _vm.isInAccountRoute
            ? _c("router-view")
            : _vm.initModal
            ? _c("on-boarding", {
                on: {
                  logout: function ($event) {
                    return _vm.logout()
                  },
                  close: function ($event) {
                    return _vm.checkIfOnboardingFinished()
                  },
                },
              })
            : _vm.appReady
            ? [
                _c("the-toolbar"),
                _c("app-create-new-book-year"),
                _c(
                  "transition",
                  { attrs: { name: "fast-fade", mode: "out-in" } },
                  [_vm.showRoute ? _c("router-view") : _vm._e()],
                  1
                ),
                _c("app-modal-service-container"),
                _c(
                  "w-modal",
                  { attrs: { value: _vm.createReportSettings != null } },
                  [
                    _vm.createReportSettings
                      ? _c("app-report-asked-filters-modal", {
                          attrs: {
                            settings: _vm.createReportSettings.settings,
                            "report-type": _vm.createReportSettings.type,
                          },
                          on: {
                            close: function ($event) {
                              _vm.createReportSettings = null
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                _vm.queuedReport
                  ? _c(
                      "w-modal",
                      { attrs: { value: "" } },
                      [
                        _c("app-report-status", {
                          attrs: { job: _vm.queuedReport },
                          on: {
                            close: function ($event) {
                              _vm.queuedReport = false
                            },
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _c(
                  "w-modal",
                  {
                    model: {
                      value: _vm.switchSessionModalOpen,
                      callback: function ($$v) {
                        _vm.switchSessionModalOpen = $$v
                      },
                      expression: "switchSessionModalOpen",
                    },
                  },
                  [
                    _c("app-session-switch-modal", {
                      on: {
                        switch: function ($event) {
                          return _vm.onSwitchSessionCallback(true)
                        },
                        signout: function ($event) {
                          return _vm.onSwitchSessionCallback(false)
                        },
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "w-modal",
                  { attrs: { value: !_vm.areSocketsConnected } },
                  [_c("app-no-connection-modal")],
                  1
                ),
                _c(
                  "w-modal",
                  { attrs: { value: _vm.showUpgradeModal } },
                  [
                    _c("app-upgrade-modal", {
                      attrs: { tier: _vm.upgradeTier },
                    }),
                  ],
                  1
                ),
                _c("app-preview-image-modal", {
                  attrs: { value: _vm.imageUrl },
                  on: {
                    input: function ($event) {
                      return _vm.closePreviewImage()
                    },
                  },
                }),
                _vm.imageUrlList
                  ? _c("app-preview-image-list-modal", {
                      attrs: { value: _vm.imageUrlList },
                      on: {
                        close: function ($event) {
                          return _vm.closePreviewImageList()
                        },
                      },
                    })
                  : _vm._e(),
                _c("app-aws-files-modal-list"),
                _vm._l(_vm.toPreviewAwsFiles, function (file, i) {
                  return _c(
                    "w-modal",
                    {
                      key: file.uid,
                      staticClass: "w100 preview",
                      attrs: {
                        value: "",
                        "full-height": "",
                        "escape-close": "",
                      },
                      on: {
                        input: function ($event) {
                          return _vm.removeAwsFilePreview(i)
                        },
                      },
                    },
                    [
                      _c("app-aws-file-preview-modal", {
                        attrs: { file: file },
                        on: {
                          close: function ($event) {
                            return _vm.removeAwsFilePreview(i)
                          },
                        },
                      }),
                    ],
                    1
                  )
                }),
              ]
            : _vm._e(),
          _vm.showRestartButton
            ? _c(
                "w-col",
                { staticClass: "restart-button", attrs: { center: "" } },
                [
                  _c("w-spacer"),
                  _c("w-spacer"),
                  _c("w-spacer"),
                  _c(
                    "w-row",
                    { attrs: { center: "" } },
                    [
                      _c(
                        "w-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.clearApp()
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(_vm.$ct("restart")) + " ")]
                      ),
                    ],
                    1
                  ),
                  _c("w-spacer"),
                ],
                1
              )
            : _vm._e(),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }